import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function Banner({ text, endDate }) {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!endDate) return;

    const updateTimer = () => {
      const now = new Date();
      const end = new Date(endDate);
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft('Offre expirée');
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft(
        `${days > 0 ? days + 'j ' : ''}${hours
          .toString()
          .padStart(2, '0')}h ${minutes
          .toString()
          .padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`
      );
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [endDate]);

  const isActive = !endDate || new Date() <= new Date(endDate);
  if (!isActive) return null;

  return (
    <div
      style={{
        background: '#2f3b52',
        color: '#f7876f',
        padding: '1rem',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '1.1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1.2rem',
        flexWrap: 'wrap',
        borderBottom: '2px solid #f7876f',
      }}
    >
      {/* Icône promo */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="#f7876f"
        style={{ width: '24px', height: '24px' }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 8l7.89 7.89a2 2 0 002.83 0L21 8m-9 4h.01"
        />
      </svg>

      {/* Texte principal */}
      <span style={{ letterSpacing: '0.5px' }}>{text}</span>

      {/* Icône horloge + timer */}
      {endDate && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: '#1a1a1a',
            padding: '0.4rem 0.8rem',
            borderRadius: '4px',
            border: '1px solid #f7876f',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="#f7876f"
            style={{ width: '20px', height: '20px' }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span style={{ fontSize: '1rem' }}>{timeLeft}</span>
        </div>
      )}
    </div>
  );
}

Banner.propTypes = {
  text: PropTypes.string.isRequired,
  endDate: PropTypes.string,
};

Banner.defaultProps = {
  endDate: null,
};

export default Banner;
